import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
  } from "@material-ui/core";
  import React from "react";
  
  export const AlertConfirmDevolucion = (props) => {
    return (
      <Dialog
        fullWidth
        maxWidth={"sm"}
        open={props.open}
        // onClose={props.onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {`${props.datosAlertDevolucion.titulo}`}
        </DialogTitle>
        <DialogContent>
          <Typography style={{fontStyle: "italic", paddingLeft: "1rem"}}>{`Se procederá a cancelar la asistencia ${props.datosAlertDevolucion.mensaje}`}</Typography>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            margin: "1.5rem 0",
          }}
        >
          <Button
            style={{ margin: "0 1rem" }}
            color="primary"
            variant="contained"
            onClick={props.closeAlertModal}
          >
            Volver
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={props.confirmButtonAction}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  